import { FC, PropsWithChildren, useState } from 'react';
import { QueryClientProvider, DehydratedState, hydrate } from '@tanstack/react-query';
import { initQueryClient } from './query-client';

type Props = PropsWithChildren<{
   dehydratedPageState?: DehydratedState;
   dehydratedAppState?: DehydratedState;
}>;

export const HydratedQueryClientProvider: FC<Props> = ({
   children,
   dehydratedPageState,
   dehydratedAppState,
}) => {
   // Grab QueryClient from useState to ensure that data is not shared between requests, while also
   // only creating the QueryClient once per component lifecycle.
   // See https://react-query.tanstack.com/guides/ssr#using-hydration
   const [queryClient] = useState(() => {
      const queryClient = initQueryClient();
      if (dehydratedAppState) {
         hydrate(queryClient, dehydratedAppState);
      }
      if (dehydratedPageState) {
         hydrate(queryClient, dehydratedPageState);
      }
      return queryClient;
   });

   return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
